import React, { useState, useEffect }  from "react";
import TopMenuNavigation from "./top-menu-naviagtion";
import MenuNavigation from "./menu-navigation";
import MenuMobile from "./menu-mobile";
import Footer from './footer'
import styled from "styled-components"
import { COLOR_WHITE  } from "../constants/colors";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  height: 100%;

  ::-webkit-scrollbar {
    display: none;
  }
` 

const AbsoluteHeader = styled.header`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => props.itemProp}px;
  z-index: 100;
  background-color: ${COLOR_WHITE};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 95%;
  position: relative;
  box-sizing: border-box;
  margin-top: ${props => props.itemProp}px;
  margin-bottom: 30px;

  @media screen and (max-width: 600px ) {
    margin-top: 75px;
  }
`

const WrapperConnectedComponent = ({ children } : { children : any }) => {
  const [ burgerOpen, _setBurgerOpen ] = useState<boolean>(false)
  const [ headerHeight, _setHeaderHeight ] = useState<number>(100)
  const [ topMenuHeight, _setTopMenuHeight ] = useState<number>(29)
  const [ menuHeight, _setMenuHeight ] = useState<number>(75)

  useEffect(() => {
    _setHeaderHeight(menuHeight + topMenuHeight)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topMenuHeight, menuHeight]) 
  
  return ( 
    <Wrapper>
      <AbsoluteHeader itemProp={headerHeight.toString()}>
        <TopMenuNavigation topMenuHeight={topMenuHeight} _setTopMenuHeight={_setTopMenuHeight}/>
        <MenuNavigation burgerOpen={burgerOpen} _setBurgerOpen={_setBurgerOpen} menuHeight={menuHeight} _setMenuHeight={_setMenuHeight}/>
      </AbsoluteHeader>
      <Content itemProp={headerHeight.toString()}>
        <MenuMobile burgerOpen={burgerOpen} _setBurgerOpen={_setBurgerOpen} headerHeight={headerHeight}/>
        {children}
      </Content>
      <Footer/>
    </Wrapper>
  );
};

export default WrapperConnectedComponent;